import { routeToSpecificScope } from "../../helpers/helpersts";
import { SERVER } from "../../config/server.config";
import { requestData } from "../../config/services/datasets";
import {
  addLoadingFlag,
  changeMessageLoading,
  subLoadingFlag,
} from "./loading";
import { DEFAULT_PERIOD_TYPES } from "../../config/constants";
import { Dispatch } from "redux";
import { RootState } from "../reducers";
import { AppThunk } from "../../config/commonTypes";
import {
  PeriodType,
  PeriodTypesAction,
  PeriodTypesState,
  PeriodTypeUI,
  TeamPeriodTypes,
} from "store/types/periodTypes";

export const updatePeriodTypes = (data: PeriodTypesState["teamsById"]) => {
  return {
    type: PeriodTypesAction.UPDATE_PERIOD_TYPES,
    data,
  };
};

const normalizeTeams = (
  data: TeamPeriodTypes[]
): Record<string, PeriodTypeUI[]> => {
  return Object.fromEntries(
    data.map((team) => [
      team.teamId,
      team.periodtype.map((periodtype) => ({
        ...periodtype,
        id: crypto.randomUUID(), //UI only
        isEditable: !DEFAULT_PERIOD_TYPES.has(periodtype.name),
      })),
    ])
  );
};

export const getPeriodTypes = (teamId: string, forcedScope?: string) => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    const path = getState().router.location.pathname;
    const scope = forcedScope || routeToSpecificScope(path);
    dispatch(addLoadingFlag(scope));
    const results = await requestData(SERVER.PERIOD_TYPES(teamId));
    if (results && results.length && results[0]) {
      const parsed: TeamPeriodTypes[] = JSON.parse(results[0]);

      const normalizedPeriodTypes = normalizeTeams(parsed);
      dispatch(updatePeriodTypes(normalizedPeriodTypes));
    } else {
      dispatch(updatePeriodTypes({}));
      dispatch(
        changeMessageLoading(scope, "No data matches your specified criteria")
      );
    }
    dispatch(subLoadingFlag(scope));
  };
};

export const updateCustomPeriodTypes = (
  periodTypes: PeriodType[],
  teamId: string
): AppThunk => {
  return async (dispatch, getState) => {
    const path = getState().router.location.pathname;
    const scope = routeToSpecificScope(path);
    const bodyPeriodTypes = periodTypes;
    const request = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(bodyPeriodTypes),
    };
    dispatch(addLoadingFlag(scope));
    const response = await requestData(SERVER.PERIOD_TYPES(teamId), request);
    if (response) {
      dispatch(getPeriodTypes(teamId));
    }
    dispatch(subLoadingFlag(scope));
  };
};
